import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      backgroundColor: palette.common.white,
      color: palette.text.primary,
      padding: '10px',
      fontSize: '16px',
      border: 'none',
      height: '40px',
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.boxShadow,
      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        color: palette.text.placeholder,
        opacity: '0.5'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
